export const customStyles = {
  control: (base) => ({
    ...base,
    fontSize: '14px',
    fontWeight: 'normal',
  }),
  singleValue: (base) => ({ ...base, fontSize: '14px', fontWeight: 'normal' }),
  placeholder: (base) => ({ ...base, fontSize: '14px', fontWeight: 'normal' }),
  input: (base) => ({ ...base, fontSize: '14px', fontWeight: 'normal' }),
  option: (base) => ({ ...base, fontSize: '14px', fontWeight: 'normal' }),
};